import { UserNoticeType } from '@/generated/graphql'
import type { UserNoticeDecision } from '../hooks/use-user-notice-decision'
import { UserNoticeCard } from './user-notice-card'
import { UserNoticeScreen } from './user-notice-screen'

interface UserNoticeGateProps {
  // Taken as a prop rather than resolved here: the layout holds the exposure report on the
  // same answer, and two independent reads of it would eventually disagree.
  decision: UserNoticeDecision
}

// Renders the SOFT nudge for the surface the user is on — the card on Profile, the full
// screen everywhere else.
//
// The HARD dead-end is NOT rendered here: it is mounted at the app root
// (user-notice-dead-end.tsx), because a screen that goes away when this layout unmounts is
// not a dead-end.
export function UserNoticeGate({ decision }: UserNoticeGateProps) {
  if (decision.status !== 'covered') return null
  if (decision.noticeType !== UserNoticeType.Soft) return null

  if (decision.source === 'profile') {
    return (
      <UserNoticeCard
        actionUrl={decision.actionUrl}
        source="profile"
        onDismiss={decision.dismiss}
      />
    )
  }

  return (
    <UserNoticeScreen
      actionUrl={decision.actionUrl}
      source={decision.source}
      onDismiss={decision.dismiss}
    />
  )
}
